import {useLocation} from 'react-router-dom'
import {useGlobalStore} from '../../store/hooks/useStore'
import {useEffect} from 'react'

const TITLE_INITIAL = 'Your shopping basket'
const TEXT_COMMON = 'Checkout Securely'

export const useCheckoutSummary = () => {
  const {pathname} = useLocation()
  const {setShowCheckoutSummary} = useGlobalStore()

  useEffect(() => {
    if (pathname !== '/checkout/summary') {
      setShowCheckoutSummary(false)
    }
  }, [pathname])

  return {
    title: TITLE_INITIAL,
    checkoutButtonText: TEXT_COMMON,
  }
}
